import type { PuzzleDefinition } from '@/types';

export interface PuzzleMeta {
  id: string;
  title: string;
  tier: number;
  chapter: number;
  index: number; // position within chapter
  category: string;
}

const puzzleRegistry: Map<string, PuzzleDefinition> = new Map();

export function registerPuzzle(puzzle: PuzzleDefinition): void {
  puzzleRegistry.set(puzzle.id, puzzle);
}

export function getPuzzle(id: string): PuzzleDefinition | null {
  return puzzleRegistry.get(id) ?? null;
}

export function listPuzzles(chapter?: number): PuzzleMeta[] {
  const results: PuzzleMeta[] = [];
  for (const puzzle of puzzleRegistry.values()) {
    const chapterNum = parseChapter(puzzle.id);
    const indexNum = parseIndex(puzzle.id);
    if (chapter !== undefined && chapterNum !== chapter) continue;
    results.push({
      id: puzzle.id,
      title: puzzle.metadata.title,
      tier: puzzle.tier,
      chapter: chapterNum,
      index: indexNum,
      category: puzzle.metadata.category,
    });
  }
  return results.sort((a, b) => a.chapter - b.chapter || a.index - b.index);
}

/** Resets the registry. Intended for testing only. */
export function clearRegistry(): void {
  puzzleRegistry.clear();
}

function parseChapter(id: string): number {
  const match = id.match(/ch(\d+)/);
  return match?.[1] ? parseInt(match[1], 10) : 0;
}

function parseIndex(id: string): number {
  const match = id.match(/-(\d+)$/);
  return match?.[1] ? parseInt(match[1], 10) : 0;
}
